import { useState, useEffect } from "react";

const navLinks = [
  { href: "#about", label: "О продукте" },
  { href: "#composition", label: "Состав" },
  { href: "#benefits", label: "Свойства" },
  { href: "#health", label: "Показания" },
  { href: "#technology", label: "Технология" },
  { href: "#usage", label: "Применение" },
  { href: "#product-line", label: "Продукция" },
  { href: "#testimonials", label: "Отзывы" },
  { href: "#faq", label: "FAQ" },
  { href: "#order", label: "Заказать" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-background/95 backdrop-blur-md shadow-card" : "bg-transparent"
      }`}
    >
      <div className="container mx-auto flex items-center justify-between py-4 px-4">
        <a href="#" className="flex flex-col leading-none">
          <span className="text-xs font-body tracking-[0.3em] text-primary uppercase">FARMASVET</span>
          <span className="text-lg font-display font-bold text-primary tracking-wide">ЖИВАРУС</span>
          <span className="text-[9px] text-muted-foreground/50 tracking-[0.15em]" style={{ fontFamily: "'Istok Web', serif" }}>ПУТЬ : Свет, Любовь и Радость</span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="text-sm font-body text-foreground/70 hover:text-primary transition-colors tracking-wide"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#order"
          className="hidden md:inline-flex items-center px-6 py-2.5 rounded-sm bg-primary text-primary-foreground font-body text-sm font-semibold tracking-wide hover:opacity-90 transition-opacity"
        >
          Заказать
        </a>

        <button
          onClick={() => setMobileOpen(!mobileOpen)}
          className="md:hidden text-foreground p-2"
          aria-label="Меню"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {mobileOpen ? (
              <path d="M18 6L6 18M6 6l12 12" />
            ) : (
              <path d="M3 12h18M3 6h18M3 18h18" />
            )}
          </svg>
        </button>
      </div>

      {mobileOpen && (
        <nav className="md:hidden bg-background/95 backdrop-blur-md border-t border-border px-4 pb-6">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setMobileOpen(false)}
              className="block py-3 text-sm font-body text-foreground/70 hover:text-primary transition-colors border-b border-border/30"
            >
              {l.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
};

export default Header;
